export default () => {
    apos.util.widgetPlayers.keywordSearch = {
      selector: '#keyword-search-widget-form',
      player: function (searchForm) {
        if (!searchForm) return;

        const __t = JSON.parse(searchForm.dataset.localizedValues);

        const settings = searchForm.dataset;

        const radiusButton = searchForm.querySelector('.location-radius__button');
        const radiusMenu = searchForm.querySelector('.location-radius__fields');
        const locationField = searchForm.querySelector('input[name=location]');
        const locationLat = searchForm.querySelector('input[name=location-lat]');
        const locationLng = searchForm.querySelector('input[name=location-lng]');
        const locationType = searchForm.querySelector('input[name=location-type]');
        const locationShort = searchForm.querySelector('input[name=location-short]');

        if (radiusButton && radiusMenu) {
          radiusButton.addEventListener('click', () => radiusMenu.classList.toggle('expand'));
          const radiusInputs = radiusMenu.querySelectorAll('input[type=radio]');
          radiusInputs.forEach(input => {
            input.addEventListener('click', () => {
              radiusButton.querySelector('span').innerHTML = input.value;
              radiusMenu.classList.remove('expand');
            });
          });

          document.addEventListener('click', function (e) {
            if (!e.target.closest('.location-radius__wrapper')) {
              radiusMenu.classList.remove('expand');
            }
          });
        }

        // Init places autocomplete when page is loaded
        if(initKeywordAutocomplete && google.maps.places.Autocomplete) {
          initKeywordAutocomplete();
        }

        const getMyLocationLink = searchForm.querySelector('#lnk_get_my_location');
        if(getMyLocationLink) {
          getMyLocationLink.addEventListener('click', () => getMyLocation());
        }

        function getMyLocation() {
          if (navigator.geolocation) {
            console.log('Geolocation enabled');
            navigator.geolocation.getCurrentPosition(
              (position) => {
                const { coords: { latitude, longitude }} = position;
                locationField.placeholder = locationField.getAttribute('data-placeholder');
                displayLocation(latitude, longitude);
              },
              (err) => {
                console.log('GetCurrentPosition error.', err);
                locationField.placeholder = __t['jobSearch.useMyLocationMessage'];
              }
            );
          } else {
            console.log('No geolocation support');
          }
        }

        async function displayLocation(latitude,longitude){
          var request = new XMLHttpRequest();
          var method = 'GET';
          var url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng='+latitude+','+longitude+'&sensor=true&key='+settings.googlemapkey;
          var async = true;
          locationLat.value = `${latitude.toFixed(4)}`;
          locationLng.value = `${longitude.toFixed(4)}`;

          request.open(method, url, async);
          request.onreadystatechange = function(){
            if(request.readyState == 4 && request.status == 200){
              var data = JSON.parse(request.responseText);
              const address = parseAddress(data.results);
              if(! (address && locationField)) return;
              const { formattedAddress, city, state, countryCode, locationType: locType, shortName } = address;
              locationType.value = locType || '';
              locationShort.value = shortName || '';
              if(formattedAddress)
                locationField.value = formattedAddress;
              else if(city && state && countryCode)
                locationField.value = `${city}, ${state}, ${countryCode}`;
              else
                locationField.value = city || '';
            }
          };
          request.send();
        };

        function parseAddress(results) {
          if (results[1]) {
            var country = null, countryCode = null, city = null, state = null;
            var formattedAddress = null, locationType = null, shortName = null;
            var c, lc, component;

            for (var r = 0, rl = results.length; r < rl; r += 1) {
              var result = results[r];

              if (!city && result.types[0] === 'locality') {
                formattedAddress = result.formatted_address;
                locationType = result.types[0];
                for (c = 0, lc = result.address_components.length; c < lc; c += 1) {
                  component = result.address_components[c];
                  if (component.types[0] === 'locality') {
                    city = component.long_name;
                    shortName = component.short_name;
                    break;
                  }
                }
              }
              else if (!state && result.types[0] === 'administrative_area_level_1') {
                for (c = 0, lc = result.address_components.length; c < lc; c += 1) {
                  component = result.address_components[c];

                  locationType = locationType || result.types[0];
                  if (component.types[0] === 'administrative_area_level_1') {
                    state = component.short_name;
                    shortName = shortName || component.short_name;
                    break;
                  }
                }
              } else if (!country && result.types[0] === 'country') {
                locationType = locationType || result.types[0];
                country = result.address_components[0].long_name;
                countryCode = result.address_components[0].short_name;
                shortName = shortName || countryCode;
              }

              if (city && state &&country) {
                break;
              }
            }

            return { formattedAddress, city, state, country, countryCode, locationType, shortName };
          }
          return null;
        }

      }
    }
  }
